import { useEffect, useState } from "react";

export function useOtpCooldown() {
  const [remainingSeconds, setRemainingSeconds] = useState(0);

  useEffect(() => {
    if (remainingSeconds <= 0) return;
    const timer = window.setTimeout(() => {
      setRemainingSeconds((current) => Math.max(0, current - 1));
    }, 1000);
    return () => window.clearTimeout(timer);
  }, [remainingSeconds]);

  return {
    remainingSeconds,
    start: (seconds?: number) => {
      const selected = Number.isFinite(seconds) ? Number(seconds) : 60;
      setRemainingSeconds(Math.max(0, Math.floor(selected)));
    },
  };
}
